const button = document.querySelector('.description-expand');
button.addEventListener('click', () => {
  const wrapper = document.querySelector('.description-collapse');
  wrapper.classList.add('description-collapse--expanded');
  button.remove();
});
